<template>
  <div class="card__header">
    <component
      :is="(event ? 'button' : 'h3')"
      v-if="text"
      class="card__title"
      @[event]="onClick"
      v-text="text"
    />
    <slot />
  </div>
</template>

<script>
export default {
	props: {
		event: {
			type: String,
			default: null
		},
		text: {
			type: String,
			default: null
		}
	},
	methods: {
		onClick: function() {
			this.$emit('onClick');
		}
	}
};
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
	.card {
		&__header {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: $white;
			color: $primary;
      padding: $card-padding-y-sm $card-padding-x-sm;
      box-shadow: 0 2px 5px 0 rgba($bali, 0.25);
			border-radius: 4px 4px 0 0;
			border-width: 2px 0 0 0;
			border-style: solid;
			border-color: rgba($tangerine, 0.3);
      @include minpoint(tablet) {
        padding: $card-padding-y $card-padding-x;
      }
		}
		&__title {
			padding: 0;
			margin-bottom: 0;
			font-weight: 700;
      line-height: $headings-line-height;
      @include minpoint(tablet) {
        font-size: $font-size-lg;
      }
			@at-root button#{&} {
				text-align: left;
				background: inherit;
				color: inherit;
				border: none;
				outline: none;
			}
		}
	}
</style>
